import React, { Component } from 'react'
import cookie from 'react-cookies'
import moment from 'moment'

import { getSpecificVideoStatus } from '../../Api/videoApi'

import Player from './Red_Player.tsx'

class VideoScreenContainer extends Component {
  // 96BA8A62

  getCurrentVideoInfo = async () => {
    let currentVideo = await getSpecificVideoStatus(
      this.props.location.state.videoApiId,
      this.props.location.state.isThisPaidContentFolder
    )

    this.setState({
      currentVideo: currentVideo[0],
    })
  }

  setIosOption = () => {
    function waitForElementToDisplay(selector, time) {
      if (document.querySelector(selector) != null) {
        document.querySelector(selector).setAttribute('playsinline', '')
        document.querySelector(selector).setAttribute('type', 'video/mp4')
        return
      } else {
        setTimeout(function () {
          waitForElementToDisplay(selector, time)
        }, time)
      }
    }

    waitForElementToDisplay('.video-react-video', 150)
  }

  isThisUnlockableFolder = () => {
    let albumName = this.state.albumName
    if (albumName) {
      albumName.toLowerCase()

      if (albumName.includes('MIAZGA')) {
        this.setState({
          isUnlockableAlbum: true,
        })
      }
    }
  }

  callbackFunc = (type) => {
    this.setState({
      userConnection: type,
    })
  }

  goFullScreen = () => {
    document.addEventListener('fullscreenchange', () => {
      this.setState({
        isFullScreen: !this.state.isFullScreen,
      })
    })
  }

  throttle(callback, interval) {
    let enableCall = true

    return function (...args) {
      if (!enableCall) return

      enableCall = false
      callback.apply(this, args)
      setTimeout(() => (enableCall = true), interval)
    }
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  onVideoLoad = () => {
    this.setLoader()
  }

  hideControls = () => {
    let timeout
    const duration = 3000

    const listenerFunction = () => {
      this.setState({
        hideFSControls: false,
      })
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.setState({
          hideFSControls: true,
        })
      }, duration)
    }

    document.addEventListener('mousemove', this.throttle(listenerFunction, 500))

    document.addEventListener('click', () => {
      this.setUserWatchedVideos()
      if (this.state.hideFSControls && !this.state.videoPlaying) {
        this.setState({
          hideFSControls: false,
        })
        document.removeEventListener('mousemove', () => {
          listenerFunction()
        })
      } else {
        listenerFunction()
      }
    })
  }

  setVideoPlaying = (isVideoPlaying) => {
    this.setState({
      videoPlaying: isVideoPlaying,
    })
  }

  setVideoTime = (videoFullTime) => {
    this.setState({
      videoFullTime: videoFullTime / 60,
    })
  }

  storeWatchedVideo = () => {
    this.props.userActions.addVideoViewInfo(
      this.state.video.resource_key,
      this.state.userWatchedVideos.folderName,
      this.state.userWatchedVideos
    )
  }

  setUserWatchedVideos = () => {
    this.setState({
      userWatchedVideos: {
        videoName: this.state.video.name,
        videoUri: this.state.video.uri,
        videoResourceKey: this.state.video.resource_key,
        folderApiEndpoint: this.props.location.state.folderApiPath,
        folderName: this.props.location.state.folder,
        lastPlayedDate: moment(),
      },
    })
  }

  saveCurrentVideoTime = (timeSeconds, percentage) => {
    this.setState({
      userWatchedVideos: {
        ...this.state.userWatchedVideos,
        currentVideoPlayedTimeSeconds: timeSeconds,
        currentVideoPlayedTimePercentage: parseFloat(percentage.toFixed(2)),
      },
    })
  }

  goBack = () => {
    if (this.state.currentVideoPlayedTimePercentage >= 80) {
      cookie.save('userCompletedTraining', true, { path: '/' })
    }
    setTimeout(() => {
      this.props.history.goBack()
    }, 500)
  }

  toggleInclompleteTrainingPopupOpen = () => {
    this.setState({
      isInclompleteTrainingPopupOpen:
        !this.state.isInclompleteTrainingPopupOpen,
    })
  }

  toggleRequestErrorAfterWatchedVideoPopupOpen = (error, isAnotherError) => {
    this.setState({
      isRequestErrorAfterWatchedVideoPopup:
        !this.state.isRequestErrorAfterWatchedVideoPopup,
      error: error,
      isAnotherError: isAnotherError,
    })
  }

  toggleNoConnectionPopupOpen = () => {
    this.setState({
      isNoConnectionPopupOpen: true,
    })
  }
  toggleNoConnectionPopupClose = () => {
    this.setState({
      isNoConnectionPopupOpen: false,
    })
  }

  toggleUserOnlineStatus = (online) => {
    this.setState({
      isUserOnline: online,
    })
  }

  render() {
    return (
      <Player
        albumName={this.props.location.state.albumName}
        isIntro={this.props.location.state.isIntro}
        videoId={this.props.location.state.videoId}
        videoOrder={this.props.location.state.videoOrder}
        albumId={this.props.location.state.albumId}
        challengeMode={this.props.location.state.challengeMode}
        videoName={this.props.location.state.videoName}
        isFav={this.props.location.state.isFav}
      />
    )
  }
}

export default VideoScreenContainer
